import React  from "react";

import defaultImage from '../assets/img/empty_item.png'
import { getImageUrl } from "../api/iposApi";

const Image = ({ image, useDefaultEmpty, onClickEvent}) => {
  
    return (
        <img className="img-responsive"
            src={getImageUrl(image, useDefaultEmpty)}
            onError={ev=>{
                ev.target.src = defaultImage;
                ev.onError = null;
            }}
            alt="iPos Web Delivery"
            onClick={onClickEvent}            
        />
    );
  };
  
  export default Image;